"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getAssetMetadataField;

function getAssetMetadataField(fieldname, asset) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$fallback = _ref.fallback,
      fallback = _ref$fallback === void 0 ? '' : _ref$fallback;

  if (!asset || !asset.metaData) {
    return fallback;
  }

  try {
    var metaData = JSON.parse(asset.metaData);
    return metaData[fieldname] || fallback;
  } catch (e) {
    return fallback;
  }
}